import {React, useState, useEffect} from "react";
import {SearchBar} from "./SearchBar";
import { WorkoutCardList } from "./WorkoutCardList";
import { getDatabase, ref, child, get } from "firebase/database";

//Renders the workout cards tagged with the "Weight Training" category by users on the respective subpage.
//Imports WorkoutCardList from WorkoutCardList.js in order to retrieve content.
export default function Weight() { 
    const [weightSnapshotArray, setWeightSnapshotArray] = useState([]);

useEffect(() => {
    const dbRef = ref(getDatabase());
    get(child(dbRef, 'Weight Training')).then((snapshot) => {
        const weightSnapshot = snapshot.val();
        const weightSnapshotKeys = Object.keys(weightSnapshot);
        const weightSnapshotArray = weightSnapshotKeys.map((key) => {
            const singlePostCopy = {...weightSnapshot[key]};
            singlePostCopy.key = key;
            return singlePostCopy;
        });
        setWeightSnapshotArray(weightSnapshotArray);
    });
}, []);
    
  return(
    <body>
    <main>
      <section className="featured-workouts">
        <h2>Weight</h2>
        <SearchBar aria-label="SearchBar"array={weightSnapshotArray} setArray={setWeightSnapshotArray} category={"Weight Training"}/>
        <WorkoutCardList aria-label="Workout Cards" renderedCardsArray={weightSnapshotArray}/>
      </section>
    </main>
    </body>
  );
}